// Preview only; the server recalculates under the account lock before moving funds.
export function depositTargetPlan (account, target) {
  const cents = value => Math.round(Number(value || 0) * 100)
  const current = cents(account.deposit)
  const oldTarget = cents(account.depositTarget)
  const next = cents(target)
  const gap = Math.max(next - current, 0)
  const available = Math.max(cents(account.availableBalance), 0)
  const transferIn = next > oldTarget && available >= gap ? gap : 0
  const transferOut = next < oldTarget ? Math.max(current - next, 0) : 0
  return { transferIn: transferIn / 100, transferOut: transferOut / 100, shortfall: Math.max(next - current - transferIn + transferOut, 0) / 100 }
}
